import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import DoubleTranslatedCustomRichText from '@/components/CustomRichText/DoubleTranslatedCustomRichText';import AccordionPanel from '@/components/UI/AccordionPanel/AccordionPanel';
import InfoMsg from '@/components/UI/InfoMsg/InfoMsg';
import Spinner from '@/components/UI/Spinner/Spinner';
import * as Constants from '@/helpers/constants';
import { getEditorId, removeParagraphTags, tabLowerCase } from '@/helpers/utils';
import useToastContext from '@/hooks/useToastContext';
import { setHelpHardware } from '@/redux/Help/help.action';
import { getHelpHardware } from '@/redux/Help/help.reducer';
import administrationServices from '@/services/administrationServices';
import { ReduxHelp } from '@/types';
import styles from '../HelpText.module.scss';

interface HardwareHelpTextProps {
  helpHardware: ReduxHelp;
  setHardware: (help: ReduxHelp) => void;
}

const HardwareHelpText: React.FC<HardwareHelpTextProps> = (props) => {
  const { t } = useTranslation();
  const tab = tabLowerCase(window.location.pathname.split('/')[4]);
  const [originalValues, setOriginalValues] = useState({});
  const { helpHardware, setHardware } = props;
  const isLoading = helpHardware && !helpHardware.AFFECTED_HARDWARE_TAB;
  const { addToast } = useToastContext();
  const AFFECTED_HARDWARE_TAB = 'AFFECTED_HARDWARE_TAB';
  const AFFECTED_HARDWARE_REQUIREMENTS = 'AFFECTED_HARDWARE_REQUIREMENTS';
  const AFFECTED_HARDWARE_PART_AVAIBILITY = 'AFFECTED_HARDWARE_PART_AVAIBILITY';
  const AFFECTED_HARDWARE_WITH_PART_CHANGE = 'AFFECTED_HARDWARE_WITH_PART_CHANGE';
  const AFFECTED_HARDWARE_WITHOUT_PART_CHANGE = 'AFFECTED_HARDWARE_WITHOUT_PART_CHANGE';
  const ID_GENERAL_HARDWARE = 'general-hardware';
  const ID_REQUIREMENTS_HARDWARE = 'requirements-hardware';
  const ID_PARTS_AVAILABILITY = 'parts-availability';
  const ID_WITH_PART_HARDWARE = 'with-part-hardware';
  const ID_WITHOUT_PART_HARDWARE = 'without-part-hardware';

  useEffect(() => {
    administrationServices.getHelp(tab)
      .then((data) => {
        const values = helpHardware && helpHardware.modified ? helpHardware : data;
        setHardware(values);
        setOriginalValues(values);
      })
      .catch((error) => addToast(error.message, 'ERROR'));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleWysiwygChange = (lang, label, data) => {
    const propValues = { ...helpHardware[label] };
    const isModified = removeParagraphTags(data) !== removeParagraphTags(originalValues[label][lang]);
    const newState = {
      ...helpHardware,
      [label]: {
        ...propValues,
        [lang]: data,
      },
      modified: isModified,
    };

    if (isModified) {
      setHardware(newState as unknown as ReduxHelp);
      setOriginalValues(newState);
    }
  };

  return (
    <>
      {isLoading && <Spinner isVisible isMask />}
      {!isLoading && (
        <>
          <InfoMsg msg={t('administration.helpText.info')} />
          <AccordionPanel title={t('administration.helpText.generalText')}>
            <DoubleTranslatedCustomRichText
              id={ID_GENERAL_HARDWARE}
              title={t('helptext')}
              initialValue={helpHardware?.AFFECTED_HARDWARE_TAB}
              handleInputChange={(lang, newValue) => handleWysiwygChange(lang, AFFECTED_HARDWARE_TAB, newValue)}
            />
          </AccordionPanel>
          <AccordionPanel title={`${t('campaignRequests.title')}: ${t('hardware.decisionTypeCampaign')}`}>
            <DoubleTranslatedCustomRichText
              id={ID_REQUIREMENTS_HARDWARE}
              title={t('helptext')}
              initialValue={helpHardware?.AFFECTED_HARDWARE_REQUIREMENTS}
              handleInputChange={(lang, newValue) => handleWysiwygChange(lang, AFFECTED_HARDWARE_REQUIREMENTS, newValue)}
            />
          </AccordionPanel>
          <AccordionPanel title={`${t('campaignRequests.title')}: ${t('hardware.partsAvailability')}`}>
            <DoubleTranslatedCustomRichText
              id={ID_PARTS_AVAILABILITY}
              title={t('helptext')}
              initialValue={helpHardware?.AFFECTED_HARDWARE_PART_AVAIBILITY}
              handleInputChange={(lang, newValue) => handleWysiwygChange(lang, AFFECTED_HARDWARE_PART_AVAIBILITY, newValue)}
            />
          </AccordionPanel>
          <AccordionPanel title={`${t('campaignRequests.title')}: ${t('hardware.reworkWithPartReplacement')}`}>
            <DoubleTranslatedCustomRichText
              id={ID_WITH_PART_HARDWARE}
              title={t('helptext')}
              initialValue={helpHardware?.AFFECTED_HARDWARE_WITH_PART_CHANGE}
              handleInputChange={(lang, newValue) => handleWysiwygChange(lang, AFFECTED_HARDWARE_WITH_PART_CHANGE, newValue)}
            />
          </AccordionPanel>
          <AccordionPanel title={`${t('campaignRequests.title')}: ${t('hardware.reworkWithoutPartReplacement')}`}>
            <DoubleTranslatedCustomRichText
              id={ID_WITHOUT_PART_HARDWARE}
              title={t('helptext')}
              initialValue={helpHardware?.AFFECTED_HARDWARE_WITHOUT_PART_CHANGE}
              handleInputChange={(lang, newValue) => handleWysiwygChange(lang, AFFECTED_HARDWARE_WITHOUT_PART_CHANGE, newValue)}
            />
          </AccordionPanel>
        </>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  helpHardware: getHelpHardware(state),
});

const actionCreators = {
  setHardware: setHelpHardware,
};

export default connect(mapStateToProps, actionCreators)(HardwareHelpText);
